import {
  Companion_getInstancengmzgdfq20id as Companion_getInstance,
  NotificationFrequency6nobdojsdzj9 as NotificationFrequency,
  TimeInZone1aol3tfiawf3k as TimeInZone,
} from './shared.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DayOfWeek37vs35iepos46 as DayOfWeek } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DayOfWeek.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareNotificationFrequencyFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [NotificationFrequency_onlyAt_getInstance(), NotificationFrequency_onlyOn_getInstance(), NotificationFrequency_batchMinutes_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function NotificationFrequency_onlyAt$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function NotificationFrequency_onlyAt$_get_name_$ref_mwks9y() {
  return (p0) => p0.i20();
}
function NotificationFrequency_onlyAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function NotificationFrequency_onlyAt$_get_serializer_$ref_6msu4h() {
  return (p0) => p0.h2j();
}
function NotificationFrequency_onlyAt$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function NotificationFrequency_onlyAt$_get_annotations_$ref_8n6ufv() {
  return (p0) => p0.bz();
}
var NotificationFrequency_onlyAtClass;
function NotificationFrequency_onlyAt() {
  if (NotificationFrequency_onlyAtClass === VOID) {
    class $ {
      constructor() {
        NotificationFrequency_onlyAt_instance = this;
        var tmp = this;
        tmp.l8o_1 = lazy(NotificationFrequency_onlyAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m8o_1 = lazy(NotificationFrequency_onlyAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n8o_1 = lazy(NotificationFrequency_onlyAt$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.l8o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, NotificationFrequency_onlyAt$_get_name_$ref_mwks9y(), null);
        return tmp0.f2();
      }
      o8o(receiver) {
        return receiver.p8o_1;
      }
      k2j(receiver) {
        return this.o8o(receiver instanceof NotificationFrequency() ? receiver : THROW_CCE());
      }
      s8o(receiver, value) {
        return receiver.t8o(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof NotificationFrequency() ? receiver : THROW_CCE();
        return this.s8o(tmp, (value == null ? true : value instanceof TimeInZone()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m8o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, NotificationFrequency_onlyAt$_get_serializer_$ref_6msu4h(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n8o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, NotificationFrequency_onlyAt$_get_annotations_$ref_8n6ufv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'NotificationFrequency_onlyAt', VOID, VOID, [SerializableProperty()]);
    NotificationFrequency_onlyAtClass = $;
  }
  return NotificationFrequency_onlyAtClass;
}
var NotificationFrequency_onlyAt_instance;
function NotificationFrequency_onlyAt_getInstance() {
  if (NotificationFrequency_onlyAt_instance === VOID)
    new (NotificationFrequency_onlyAt())();
  return NotificationFrequency_onlyAt_instance;
}
function NotificationFrequency_onlyOn$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function NotificationFrequency_onlyOn$_get_name_$ref_vqxcsa() {
  return (p0) => p0.i20();
}
function NotificationFrequency_onlyOn$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function NotificationFrequency_onlyOn$_get_serializer_$ref_deqsa5() {
  return (p0) => p0.h2j();
}
function NotificationFrequency_onlyOn$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function NotificationFrequency_onlyOn$_get_annotations_$ref_5m33e7() {
  return (p0) => p0.bz();
}
var NotificationFrequency_onlyOnClass;
function NotificationFrequency_onlyOn() {
  if (NotificationFrequency_onlyOnClass === VOID) {
    class $ {
      constructor() {
        NotificationFrequency_onlyOn_instance = this;
        var tmp = this;
        tmp.u8o_1 = lazy(NotificationFrequency_onlyOn$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v8o_1 = lazy(NotificationFrequency_onlyOn$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w8o_1 = lazy(NotificationFrequency_onlyOn$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.u8o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, NotificationFrequency_onlyOn$_get_name_$ref_vqxcsa(), null);
        return tmp0.f2();
      }
      o8o(receiver) {
        return receiver.q8o_1;
      }
      k2j(receiver) {
        return this.o8o(receiver instanceof NotificationFrequency() ? receiver : THROW_CCE());
      }
      x8o(receiver, value) {
        return receiver.t8o(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof NotificationFrequency() ? receiver : THROW_CCE();
        return this.x8o(tmp, (value == null ? true : value instanceof DayOfWeek()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.v8o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, NotificationFrequency_onlyOn$_get_serializer_$ref_deqsa5(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w8o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, NotificationFrequency_onlyOn$_get_annotations_$ref_5m33e7(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'NotificationFrequency_onlyOn', VOID, VOID, [SerializableProperty()]);
    NotificationFrequency_onlyOnClass = $;
  }
  return NotificationFrequency_onlyOnClass;
}
var NotificationFrequency_onlyOn_instance;
function NotificationFrequency_onlyOn_getInstance() {
  if (NotificationFrequency_onlyOn_instance === VOID)
    new (NotificationFrequency_onlyOn())();
  return NotificationFrequency_onlyOn_instance;
}
function NotificationFrequency_batchMinutes$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function NotificationFrequency_batchMinutes$_get_name_$ref_y72an4() {
  return (p0) => p0.i20();
}
function NotificationFrequency_batchMinutes$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function NotificationFrequency_batchMinutes$_get_serializer_$ref_qzj5on() {
  return (p0) => p0.h2j();
}
function NotificationFrequency_batchMinutes$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function NotificationFrequency_batchMinutes$_get_annotations_$ref_bub11() {
  return (p0) => p0.bz();
}
var NotificationFrequency_batchMinutesClass;
function NotificationFrequency_batchMinutes() {
  if (NotificationFrequency_batchMinutesClass === VOID) {
    class $ {
      constructor() {
        NotificationFrequency_batchMinutes_instance = this;
        var tmp = this;
        tmp.y8o_1 = lazy(NotificationFrequency_batchMinutes$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z8o_1 = lazy(NotificationFrequency_batchMinutes$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a8p_1 = lazy(NotificationFrequency_batchMinutes$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.y8o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, NotificationFrequency_batchMinutes$_get_name_$ref_y72an4(), null);
        return tmp0.f2();
      }
      o8o(receiver) {
        return receiver.r8o_1;
      }
      k2j(receiver) {
        return this.o8o(receiver instanceof NotificationFrequency() ? receiver : THROW_CCE());
      }
      b8p(receiver, value) {
        return receiver.t8o(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof NotificationFrequency() ? receiver : THROW_CCE();
        return this.b8p(tmp, (value == null ? true : typeof value === 'number') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.z8o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, NotificationFrequency_batchMinutes$_get_serializer_$ref_qzj5on(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a8p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, NotificationFrequency_batchMinutes$_get_annotations_$ref_bub11(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'NotificationFrequency_batchMinutes', VOID, VOID, [SerializableProperty()]);
    NotificationFrequency_batchMinutesClass = $;
  }
  return NotificationFrequency_batchMinutesClass;
}
var NotificationFrequency_batchMinutes_instance;
function NotificationFrequency_batchMinutes_getInstance() {
  if (NotificationFrequency_batchMinutes_instance === VOID)
    new (NotificationFrequency_batchMinutes())();
  return NotificationFrequency_batchMinutes_instance;
}
//region block: exports
export {
  prepareNotificationFrequencyFields as prepareNotificationFrequencyFields39u6364rcnx1g,
};
//endregion

//# sourceMappingURL=NotificationFrequencyFields.mjs.map
